<template>
    <v-dialog v-model="dialog" persistent max-width="700">
    <v-card>
      <v-card-title class="d-flax px-12 pt-12">
        <v-row>
          <v-col cols="12" align-self="center" class="px-0 d-flex">
            <span class="text-333333 font-20 w-700" style="align-self: center;">จัดการ Mini App</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="closePage()" small color="#00A99D">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class=" pb-0">
        <v-row style="background-color: #ceefed;" class="ma-4">
          <v-col cols="12">
            <v-row>
              <v-col cols="12" class="px-10">
                <v-radio-group
                  v-model="action"
                  row
                  hide-details="auto"
                >
                  <v-radio
                    label="เพิ่ม Mini App"
                    value="add"
                    color="#00A99D"
                  ></v-radio>
                  <v-radio
                    label="ลบ Mini App"
                    value="delete"
                    color="#FF8082"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="px-10">
                <span class="font-16 w-00 text-333333">องค์กร</span>
                <v-autocomplete
                  :items="itemTable"
                  item-value="biz_id"
                  item-text="first_name_th"
                  :menu-props="{ bottom: true, offsetY: true }"
                  solo
                  dense
                  hide-details="auto"
                  placeholder="กรุณาเลือกองค์กร"
                  v-model="hospital_detail.organization"
                  item-color="teal darken-2"
                  color="#00A99D"
                  :rules="rule_organization"
                >
                  <template slot="no-data">
                    <span class="pl-2">ไม่มีข้อมูลองค์กร</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" class="px-10" v-if="hospital_detail.organization == 'อื่นๆ'">
                <span class="font-16 w-00 text-333333">Business ID</span>
                <v-text-field
                  v-model="hospital_detail.add_biz_id"
                  placeholder="กรุณากรอก Business ID"
                  solo
                  dense
                  hide-details="auto"
                  color="#00a99d"
                  :rules="rule_business"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="px-10 pb-10">
                <span class="font-16 w-00 text-333333">Mini App</span>
                <v-select
                  v-model="mini_app"
                  :items="items"
                  item-value="name"
                  placeholder="Mini App"
                  solo
                  dense
                  color="#00a99d"
                  item-color="teal darken-2"
                  :rules="rule_mini"
                  hide-details="auto"
                  :menu-props="{ bottom: true, offsetY: true }"
                >
                  <template v-slot:selection="{ item }">
                    <v-chip color="#00a99d" outlined dark>
                      <v-avatar left size="120">
                        <img :src="item.image"/>
                      </v-avatar>
                      <span class="font-16 text-333333 ">{{ item.name }}</span>
                    </v-chip>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-chip color="#00a99d" outlined dark>
                      <v-avatar left size="120">
                        <img :src="item.image"/>
                      </v-avatar>
                      <span class="font-16 text-007C92 ">{{ item.name }}</span>
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row justify="center" align="center" class="ma-0 pb-3">
          <v-col cols="12" sm="4" md="4" class="pt-0">
            <v-btn
              depressed
              block
              color="#00A99D"
              dark
              style="border-radius: 20px 5px;"
              @click="checkMiniApp()"
            >
              <span class="font-16 w-500">บันทึก</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      itemTable: [],
      mini_app: '',
      action:"add",
      hospital_detail: {
        organization: '',
        biz_id: '',
        add_biz_id: '',
      },
      items: [
        { name: 'Tele_Health', image: require('@/assets/image/TeleHealth.svg')},
        { name: 'D_Health', image: require('@/assets/image/DHealth.svg')},
        { name: 'DHI_Tele', image: require('@/assets/image/DHI.svg')},
        { name: 'Test_DHI_Tele', image: require('@/assets/image/DHI.svg')},
        { name: 'Tele_Consult', image: require('@/assets/image/Tele.svg')},
        { name: 'Test_Tele_Consult', image: require('@/assets/image/Tele.svg')},
        { name: 'หมอใกล้ฉัน(UAT)', image: require('@/assets/image/logo-doctor-near-me-small.png')},
        { name: 'หมอใกล้ฉัน(ทดสอบ)', image: require('@/assets/image/logo-doctor-near-me-small.png')}
      ],
      rule_organization: [(v) => !!v || "กรุณาเลือกองค์กร"],
      rule_business: [(v) => !!v || "กรุณากรอก BusinessID"],
      rule_mini: [(v) => !!v || "กรุณาเลือก Mini App"],
    }
  },
  methods: {
    openDialog() {
      this.itemTable = []
      this.mini_app= '',
      this.hospital_detail = {
        organization: '',
        biz_id: '',
      }
      this.dialog = true
      this.getOrganizeData()
    },
    closePage() {
      this.itemTable = []
      this.mini_app= '',
      this.hospital_detail = {
        organization: '',
        biz_id: '',
      }
      this.dialog = false
    },
    async getOrganizeData() {
      try {
        var params = new URLSearchParams();
        params.append('limit', '')
        params.append('page', '')
        params.append('type', 'organization')

        await this.axios.post(process.env.VUE_APP_BACKEND_URL+`/v1/organization/getOrganizationOnly?${params}`)
        .then((res) => {
          if(res.data.result == 'success') {
            this.itemTable = res.data.data.data
            this.itemTable.push('อื่นๆ') 
          }
        })
      } catch(err) {
        console.log(err);
      } 
    },
    checkMiniApp() {
      // console.log('action',this.action);
      // console.log('miniapp',this.mini_app.name);
      // console.log('organization',this.hospital_detail.organization);
      // console.log('biz_id',this.hospital_detail.biz_id);
      if (this.action == 'add') {
        this.addMiniApp()
      }else if (this.action == 'delete') {
        this.deleteMiniApp()
      }
    },
    async addMiniApp() {
      console.log('add');
      try {
        if (this.hospital_detail.organization == 'อื่นๆ') {
          this.hospital_detail.organization = this.hospital_detail.add_biz_id
        }
        // console.log(this.hospital_detail.organization);
        const params = new URLSearchParams();
        params.append("mini_app", this.mini_app);
        params.append("biz_id", this.hospital_detail.organization);

        await this.axios.post(process.env.VUE_APP_BACKEND_URL+`/v1/add/mini/app?${params}`,
        ).then((res) => {
          console.log(res);
          if (res.data.code == 200 && res.data.result == "success") {
            this.$swal({
              title:
                "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>บันทึกข้อมูลสำเร็จ</span>",
              icon: "success",
              showCloseButton: false,
              showConfirmButton: false,
              background: "white",
              timer: 3000,
            });
          }else {
            this.$swal({
              title:
                "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>บันทึกข้อมูลไม่สำเร็จ</span>",
              icon: "error",
              showCloseButton: false,
              showConfirmButton: false,
              background: "white",
              timer: 3000,
            });
          }
        })
      } catch(err) {
        console.log(err);
      }
    },
    async deleteMiniApp() {
      console.log('del');
      try {
        if (this.hospital_detail.organization == 'อื่นๆ') {
          this.hospital_detail.organization = this.hospital_detail.add_biz_id
        }
        // console.log(this.hospital_detail.organization);
        const params = new URLSearchParams();
        params.append("mini_app", this.mini_app);
        params.append("biz_id", this.hospital_detail.organization);

        await this.axios.post(process.env.VUE_APP_BACKEND_URL+`/v1/delete/mini/app?${params}`,
        ).then((res) => {
          console.log(res);
          if (res.data.code == 200 && res.data.result == "success") {
            this.$swal({
              title:
                "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>บันทึกข้อมูลสำเร็จ</span>",
              icon: "success",
              showCloseButton: false,
              showConfirmButton: false,
              background: "white",
              timer: 3000,
            });
          }else {
            this.$swal({
              title:
                "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>บันทึกข้อมูลไม่สำเร็จ</span>",
              icon: "error",
              showCloseButton: false,
              showConfirmButton: false,
              background: "white",
              timer: 3000,
            });
          }
        })
      } catch(err) {
        console.log(err);
      }
    },
  }
}
</script>

<style scoped>
.v-chip.v-size--default {
  border-radius: 15px;
  font-size: 14px;
  height: 30px;
  min-width: 140px;
}

::v-deep .text_1 {
  border-radius: 20px 5px !important;
  background-color: #ffffff !important;
  padding-right: 0px;
}

::v-deep .theme--light.v-label {
  color: #1e1e1e !important;
  font-size: 18px;
  /* padding-right: 40px; */
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: 0px 0px 0px 0px !important;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
</style>